export const HOW_IT_WORKS = [
  {
    id: 1,
    title: 'Вы договариваетесь с собственником о скидке 4,1%',
    descr: 'Покупатель заплатит эту сумму банку как комиссию за снижение ставки на 4%',
    imageClass: 'percent',
  },
  {
    id: 2,
    title: 'Мы поставим значок на объявление',
    descr: 'Это привлечет внимание покупателей и вы получите больше звонков',
    imageClass: 'advert',
  },
  {
    id: 3,
    title: 'Покупатель выберет ваш объект и получит одобрение',
    descr: 'После этого можно выходить на сделку со сниженной ставкой',
    imageClass: 'house',
  },
];
